module.exports = __webpack_public_path__ + "media/images/WFC_Landscape_Black_w_0-38471f13639306b4424520545e82a869.svg";